<template>
  <div class="deal-accommodations">
    <!-- <template v-if="['de', 'ch', 'at'].includes($i18n.locale)">
      <TravelRestrictions
        v-if="
          !isInOwnCountry(
            $i18n.locale,
            accommodations[0].hotel.location.address.country,
          )
        "
        :is-mobile="isMobile"
        :location="accommodations[0].hotel.location"
        :corona-information="
          accommodations[0].hotel.location.passolutionCoronaInformation
        "
      />
    </template> -->

    <template v-if="accommodations.length === 1">
      <!-- Single -->
      <!-- <h3 class="hg-title">
        {{ $t('deal.accommodationHeading') }}
      </h3> -->
      <HgResponsiveContent :title="$t('deal.accommodationHeading')">
        <!-- eslint-disable vue/no-v-html -->
        <p
          v-if="accommodations[0].hotel.description"
          v-html="accommodations[0].hotel.description"
        />

        <HgDealHotelAttributes
          :name="accommodations[0].hotel.name"
          :stars="accommodations[0].hotel.rating"
          :attributes="accommodations[0].hotel.attributes"
        />
      </HgResponsiveContent>
    </template>
    <template v-else>
      <!-- Multiple -->
      <h3 class="hg-title">
        {{ $t('deal.accommodationHeading') }}
      </h3>

      <div class="accommodation-list">
        <button
          v-for="accommodation in accommodations"
          :key="accommodation.id"
          class="accommodation-button"
          @click="selectAccommodation(accommodation)"
        >
          <div class="accommodation-button__content">
            <hg-icon name="hotel" />
            <div class="content">
              <span class="name">
                {{ accommodation.hotel.name }}
              </span>
              <span class="rating">
                <hg-stars :rating="accommodation.hotel.rating" />
              </span>
            </div>
          </div>
          <div class="accommodation-button__chevron">
            <hg-icon name="chevron-right" />
          </div>
        </button>
      </div>
      <HgModal
        v-if="selectedAccommodation"
        class="accommodation-modal"
        :is-fullscreen="isMobile"
        @onClose="selectedAccommodation = null"
      >
        <HgHotelDetailView
          :rating="selectedAccommodation.hotel.rating"
          :name="selectedAccommodation.hotel.name"
          :description="selectedAccommodation.hotel.description"
          :images="selectedAccommodation.hotel.images"
          :location="selectedAccommodation.hotel.location"
          :attributes="selectedAccommodation.hotel.attributes"
        >
          <template #hotel-extras>
            <Map
              :lat="selectedAccommodation.hotel.location.geoCoordinate.lat"
              :lng="selectedAccommodation.hotel.location.geoCoordinate.lng"
            />
          </template>
        </HgHotelDetailView>
      </HgModal>
    </template>
  </div>
</template>

<script>
import GtmEventsMixin from '@/mixins/GtmEventsMixin';

export default {
  components: {
    Map: () => import('@/components/ui/Map'),
  },
  mixins: [GtmEventsMixin],
  props: {
    accommodations: {
      type: Array,
      default: () => []
    },
    isMobile: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    selectedAccommodation: null
  }),
  methods: {
    selectAccommodation(accommodation) {
      this.selectedAccommodation = accommodation;
      this.$gtm.push({ event: 'dealpage_open_hotel_detail_view' });
    },
    isInOwnCountry(locale, country) {
      if (locale === 'de' && country === 'Deutschland') {
        return true;
      }
      if (locale === 'ch' && country === 'Switzerland') {
        return true;
      }
      if (locale === 'at' && country === 'Austria') {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.accommodation-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.accommodation-button {
  width: 100%;
  text-align: left;
  border-bottom: 1px solid $gray-100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0;
}

.accommodation-button:hover {
  background-color: $teal-20;
}

.accommodation-button:active {
  background-color: $teal-40;
}

.accommodation-button__content {
  display: flex;
  align-items: center;
}

.accommodation-button .content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 1rem;
}

.accommodation-button .name {
  font-weight: bold;
}

.accommodation-button .rating {
  display: flex;
}

.accommodation-button__chevron {
  color: $teal-500;
}

.hg-title {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}
</style>

<style>
.accommodation-modal .hg-modal-scroll-content {
  padding: 0;
  overflow: hidden;
}

.hg-hotel__content {
  padding: 1rem;
}

.accommodation-modal .hg-modal-scroll-content h2.hg-title {
  margin-top: 0.5rem;
}
</style>
